import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateQuoteRefusalReasonModel,
  EditQuoteRefusalReasonModel,
  SearchQuoteRefusalReasonModel,
} from '../../../models/quote-refusal-reason.model'

@Injectable({
  providedIn: 'root',
})
export class QuoteRefusalReasonService {
  private baseUrl = environment.baseUrl
  private resource = 'MotivoRecusaCotacao'

  constructor(private httpClient: HttpClient) {}

  // Retorna apenas os motivos ativos - é o que alimenta o droplist do modal de recusa
  public listQuoteRefusalReason(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public listPagedQuoteRefusalReason(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public getQuoteRefusalReasonById(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public createQuoteRefusalReason(
    model: CreateQuoteRefusalReasonModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editQuoteRefusalReason(
    model: EditQuoteRefusalReasonModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public searchPagedQuoteRefusalReason(
    page: number,
    rows = 15,
    model: SearchQuoteRefusalReasonModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  // Alterna entre ativo 'S' e 'N', não recebe body
  public toggleStatusQuoteRefusalReason(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/inativar/${id}`,
      {},
    )
  }
}
